import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  box-sizing: unset;
`

export const StyledFieldSet = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;
`

export const FormFields = styled(Box)`
  display: block;
  p {
    margin: 6px 0;
  }
`
